<template>
    <div class="row">
      <div class="small-12 medium-12 large-12 columns searchRowColumn">
        <slot></slot>
      </div>
    </div>
</template>

<script setup>

</script>

<style scoped>
.searchRowColumn {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 40px;
  padding-right: 0;
  padding-left: 0;
}

@media screen and (max-width: 767px) {
  .searchRowColumn{
    flex-direction: column;
    padding: 0;
  }
}

</style>